import React, { useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonials: React.FC = () => {
  const [active, setActive] = useState("Students");

  const typeOfTestimonial = ["Students", "Parents"];

  const testimonials = [
    {
      id: 1,
      name: "Mr. and Mrs. Sharma",
      img: "https://www.growniverse.com/images//MrAndMrsSharma.webp",
      testimonial:
        "We've Seen Significant Improvement in Our Both Children's Confidence, Communication And essential life skills. Highly Recommend to other Parents",
      type: "Parents",
    },
    {
      id: 2,
      name: "Mrs. Sharda Devi",
      img: "https://www.growniverse.com/images//ShardaDevi.webp",
      testimonial:
        "The Mentors at Growniverse Provides The Best Environment Possible For Our Both Children's Progress.",
      type: "Parents",
    },
    {
      id: 3,
      name: "Mrs. Reena Devi",
      img: "https://www.growniverse.com/images//ReenaDevi.webp",
      testimonial:
        "Growniverse has an Excellent Communication System, Which Ensure that Parents are always aware of their Child shedule and performance",
      type: "Parents",
    },
    {
      id: 4,
      name: "Mrs Reshma Devi",
      img: "https://www.growniverse.com/images//ReshmaDevi.webp",
      testimonial:
        "Growniverse has Exceeded Our Expectations in every way. The Quality Education and Support has made a Significant Different in My Daughter's Life",
      type: "Parents",
    },
    {
      id: 5,
      name: "Karan Rajput",
      img: "https://www.growniverse.com/images//KaranRajput.webp",
      testimonial:
        "Growniverse is where Minds are opened and Future are Shaped.",
      type: "Students",
    },
    {
      id: 6,
      name: "Sonia Choudhary",
      img: "https://www.growniverse.com/images//SoniaChoudhary.webp",
      testimonial:
        "I am Greatful for the Skills, Knowledge and Confidence Growniverse Provide to me.",
      type: "Students",
    },
    {
      id: 7,
      name: "Bhushan Sharma",
      img: "https://www.growniverse.com/images//BhushanSharma.webp",
      testimonial:
        "You are More than a Digital Learning Platform,Your Environment is a Blessing in My Life.",
      type: "Students",
    },
    {
      id: 8,
      name: "Kajal",
      img: "https://www.growniverse.com/images//Kajal.webp",
      testimonial:
        "I am truly grateful and honored to be a part of the incredible Growniverse.",
      type: "Students",
    },
    {
      id: 9,
      name: "Jiya Sharma",
      img: "https://www.growniverse.com/images//JiyaSharma.webp",
      testimonial:
        "I improve my Communication Skills very much from Growniverse.",
      type: "Students",
    },
  ];

  const filteredTestimonials = testimonials.filter(
    (testimonial) => testimonial.type === active
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    arrows: true,
    adaptiveHeight: false,

    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      {/* =========================================================
          TESTIMONIAL SECTION
      ========================================================= */}

      <section className="growniverse-testimonials">

        {/* =======================================================
            BACKGROUND EFFECTS
        ======================================================= */}

        <div className="testimonials-grid" />

        <div className="testimonials-glow testimonials-glow-left" />

        <div className="testimonials-glow testimonials-glow-right" />

        <div className="testimonials-orb testimonials-orb-one" />

        <div className="testimonials-orb testimonials-orb-two" />

        {/* =======================================================
            TOP DECORATIVE LINE
        ======================================================= */}

        <div className="testimonials-top-line" />

        {/* =======================================================
            CONTENT
        ======================================================= */}

        <div className="container testimonials-container">

          {/* =====================================================
              HEADER
          ===================================================== */}

          <div className="testimonials-header">

            <h2 className="testimonials-title">
              Voices That
              <span> Inspire Us</span>
            </h2>

            <div className="testimonials-title-line" />

            <p className="testimonials-description">
              Every journey matters. Discover what our students and
              parents have experienced with Growniverse.
            </p>

          </div>

          {/* =====================================================
              FILTER TABS
          ===================================================== */}

          <div className="testimonials-tabs">

            {typeOfTestimonial.map((type) => {
              const isActive = active === type;

              return (
                <button
                  key={type}
                  type="button"
                  className={`testimonial-tab ${
                    isActive ? "testimonial-tab-active" : ""
                  }`}
                  onClick={() => setActive(type)}
                >
                  <span className="tab-icon">
                    {type === "Students" ? "✦" : "◆"}
                  </span>

                  {type}

                  {isActive && (
                    <span className="tab-active-line" />
                  )}
                </button>
              );
            })}

          </div>

          {/* =====================================================
              SLIDER
          ===================================================== */}

          <div className="testimonial-slider-wrapper">

            <Slider {...settings} key={active}>

              {filteredTestimonials.map((testimonial) => (

                <div
                  key={testimonial.id}
                  className="testimonial-slide"
                >

                  {/* =================================================
                      CARD
                  ================================================= */}

                  <article className="testimonial-card">

                    {/* TOP LIGHT */}
                    <div className="testimonial-card-top" />

                    {/* CORNER DECORATION */}
                    <div className="card-corner card-corner-top" />
                    <div className="card-corner card-corner-bottom" />

                    {/* =================================================
                        QUOTE
                    ================================================= */}

                    <div className="testimonial-quote">
                      "
                    </div>

                    {/* =================================================
                        PROFILE
                    ================================================= */}

                    <div className="testimonial-profile">

                      <div
                        className={`testimonial-avatar-ring ${
                          testimonial.type === "Students"
                            ? "student-ring"
                            : "parent-ring"
                        }`}
                      >
                        <div className="testimonial-avatar">

                          <img
                            src={testimonial.img}
                            alt={testimonial.name}
                          />

                        </div>
                      </div>

                      <div className="testimonial-profile-info">

                        <h3>
                          {testimonial.name}
                        </h3>

                        <span
                          className={`testimonial-type ${
                            testimonial.type === "Students"
                              ? "student-type"
                              : "parent-type"
                          }`}
                        >
                          {testimonial.type}
                        </span>

                      </div>

                    </div>

                    {/* =================================================
                        DIVIDER
                    ================================================= */}

                    <div className="testimonial-divider">
                      <span />
                      <span />
                      <span />
                    </div>

                    {/* =================================================
                        TESTIMONIAL TEXT
                    ================================================= */}

                    <p className="testimonial-text" style={{fontWeight:"bold"}}>
                      {testimonial.testimonial}
                    </p>

                    {/* =================================================
                        BOTTOM
                    ================================================= */}

                    <div className="testimonial-card-footer">

                      <div className="verified-badge">
                        <span className="verified-icon">
                          ✓
                        </span>

                        Genuine Experience
                      </div>

                      <div className="footer-symbol">
                        ◇
                      </div>

                    </div>

                    {/* BOTTOM GLOW */}

                    <div
                      className={`testimonial-bottom-glow ${
                        testimonial.type === "Students"
                          ? "student-glow"
                          : "parent-glow"
                      }`}
                    />

                  </article>

                </div>

              ))}

            </Slider>

          </div>

        </div>

        {/* =======================================================
            BOTTOM DECORATIVE LINE
        ======================================================= */}

        <div className="testimonials-bottom-line" />

      </section>

      {/* =========================================================
          COMPLETE CSS
      ========================================================= */}

     <style>{`

/* =========================================================
   GROWNIVERSE TESTIMONIALS
   COLOR SYSTEM
   Midnight Navy + Electric Blue + Violet
   ========================================================= */

.growniverse-testimonials {
  --test-blue: #38bdf8;
  --test-blue-soft: #60a5fa;
  --test-violet: #8b5cf6;
  --test-violet-soft: #a78bfa;

  --test-bg: #050914;
  --test-bg-2: #080d1b;

  position: relative;
  width: 100%;
  overflow: hidden;

  padding: 72px 0 68px;
  box-sizing: border-box;

  background:
    radial-gradient(
      circle at 12% 30%,
      rgba(56, 189, 248, 0.055),
      transparent 32%
    ),

    radial-gradient(
      circle at 88% 70%,
      rgba(139, 92, 246, 0.065),
      transparent 34%
    ),

    linear-gradient(
      135deg,
      #030711 0%,
      #050914 45%,
      #070b18 100%
    );

  border-top:
    1px solid rgba(56, 189, 248, 0.12);

  border-bottom:
    1px solid rgba(139, 92, 246, 0.14);

  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.025),
    0 -15px 50px rgba(0,0,0,0.25),
    0 20px 60px rgba(0,0,0,0.35);
}


/* =========================================================
   BACKGROUND GRID
   ========================================================= */

.growniverse-testimonials
.testimonials-grid {

  position: absolute;
  inset: 0;

  pointer-events: none;

  opacity: 0.11;

  background-image:

    linear-gradient(
      rgba(255,255,255,0.025) 1px,
      transparent 1px
    ),

    linear-gradient(
      90deg,
      rgba(255,255,255,0.025) 1px,
      transparent 1px
    );

  background-size: 42px 42px;

  mask-image:
    linear-gradient(
      to bottom,
      transparent,
      black 15%,
      black 85%,
      transparent
    );
}


/* =========================================================
   OUTER BLUE GLOW
   ========================================================= */

.testimonials-glow {

  position: absolute;

  width: 430px;
  height: 430px;

  border-radius: 50%;

  filter: blur(125px);

  pointer-events: none;

}


.testimonials-glow-left {

  left: -280px;
  top: -180px;

  background:
    rgba(56, 189, 248, 0.075);
}


.testimonials-glow-right {

  right: -280px;
  bottom: -200px;

  background:
    rgba(139, 92, 246, 0.075);
}


/* =========================================================
   SMALL LIGHT ORBS
   ========================================================= */

.testimonials-orb {

  position: absolute;

  border-radius: 50%;

  pointer-events: none;

  opacity: 0.5;
}


.testimonials-orb-one {

  width: 5px;
  height: 5px;

  left: 12%;
  top: 24%;

  background: var(--test-blue);

  box-shadow:
    0 0 14px var(--test-blue);
}


.testimonials-orb-two {

  width: 4px;
  height: 4px;

  right: 15%;
  top: 36%;

  background: var(--test-violet);

  box-shadow:
    0 0 12px var(--test-violet);
}


/* =========================================================
   SECTION TOP LINE
   ========================================================= */

.testimonials-top-line {

  position: absolute;

  top: 0;

  left: 15%;
  right: 15%;

  height: 1px;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(56,189,248,0.5),
      rgba(139,92,246,0.5),
      transparent
    );

  pointer-events: none;

}


/* =========================================================
   CONTAINER
   ========================================================= */

.testimonials-container {

  position: relative;

  z-index: 5;
}


/* =========================================================
   HEADER
   ========================================================= */

.testimonials-header {

  text-align: center;

  max-width: 720px;

  margin:
    0 auto 30px;
}


/* =========================================================
   EYEBROW
   ========================================================= */

.testimonials-eyebrow {

  display: inline-flex;

  align-items: center;

  gap: 8px;

  padding:
    6px 14px;

  margin-bottom: 13px;

  border:
    1px solid rgba(56,189,248,0.25);

  border-radius: 30px;

  background:
    rgba(56,189,248,0.035);

  color: var(--test-blue);

  font-size: 10px;

  font-weight: 800;

  letter-spacing: 2px;

  box-shadow:
    0 0 20px rgba(56,189,248,0.035);
}


.eyebrow-dot {

  width: 5px;
  height: 5px;

  border-radius: 50%;

  background:
    var(--test-blue);

  box-shadow:
    0 0 10px var(--test-blue);
}


/* =========================================================
   TITLE
   ========================================================= */

.testimonials-title {

  margin: 0;

  color: #ffffff;

  font-size:
    clamp(28px, 4vw, 44px);

  line-height: 1.15;

  font-weight: 800;

  letter-spacing: -1px;

  text-shadow:
    0 0 20px rgba(255,255,255,0.08);
}


/* =========================================================
   TITLE ACCENT
   ========================================================= */

.testimonials-title span {

  background:
    linear-gradient(
      90deg,
      #38bdf8,
      #60a5fa 45%,
      #a78bfa
    );

  -webkit-background-clip: text;

  background-clip: text;

  -webkit-text-fill-color: transparent;

  filter:
    drop-shadow(
      0 0 12px rgba(56,189,248,0.15)
    );
}


/* =========================================================
   TITLE LINE
   ========================================================= */

.testimonials-title-line {

  width: 75px;

  height: 2px;

  margin:
    14px auto 0;

  border-radius: 20px;

  background:
    linear-gradient(
      90deg,
      transparent,
      #38bdf8,
      #8b5cf6,
      transparent
    );

  box-shadow:
    0 0 10px rgba(56,189,248,0.35);
}


/* =========================================================
   DESCRIPTION
   ========================================================= */

.testimonials-description {

  max-width: 570px;

  margin:
    14px auto 0;

  color: #91a0b5;

  font-size: 13px;

  line-height: 1.7;
}


/* =========================================================
   TABS
   ========================================================= */

.testimonials-tabs {

  display: flex;

  justify-content: center;

  align-items: center;

  gap: 8px;

  flex-wrap: wrap;

  margin-bottom: 25px;
}


.testimonial-tab {

  position: relative;

  min-width: 115px;

  height: 38px;

  padding:
    0 18px;

  display: inline-flex;

  align-items: center;

  justify-content: center;

  gap: 7px;

  border:
    1px solid rgba(255,255,255,0.09);

  border-radius: 22px;

  background:
    rgba(255,255,255,0.018);

  color: #8f9caf;

  font-size: 11px;

  font-weight: 700;

  letter-spacing: 0.8px;

  cursor: pointer;

  transition:
    all 0.25s ease;
}


.testimonial-tab:hover {

  color: #dbeafe;

  border-color:
    rgba(56,189,248,0.35);

  background:
    rgba(56,189,248,0.045);

  transform:
    translateY(-1px);
}


.testimonial-tab-active {

  color: #38bdf8;

  border-color:
    rgba(56,189,248,0.48);

  background:
    linear-gradient(
      135deg,
      rgba(56,189,248,0.09),
      rgba(139,92,246,0.07)
    );

  box-shadow:
    0 0 20px rgba(56,189,248,0.055);
}


.tab-icon {

  font-size: 9px;

  opacity: 0.8;
}


.tab-active-line {

  position: absolute;

  left: 25%;
  right: 25%;

  bottom: -1px;

  height: 2px;

  border-radius: 10px;

  background:
    linear-gradient(
      90deg,
      #38bdf8,
      #8b5cf6
    );

  box-shadow:
    0 0 9px rgba(56,189,248,0.5);
}


/* =========================================================
   SLIDER WRAPPER
   THIS IS THE CONNECTING CENTER AREA
   ========================================================= */

.testimonial-slider-wrapper {

  position: relative;

  padding:
    18px 5px 38px;

  border-radius: 28px;

  background:
    linear-gradient(
      180deg,
      rgba(9,15,29,0.52),
      rgba(6,11,23,0.28)
    );

  border:
    1px solid rgba(56,189,248,0.065);

  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.018),
    0 20px 60px rgba(0,0,0,0.16);
}


/* =========================================================
   CENTER AMBIENT GLOW
   ========================================================= */

.testimonial-slider-wrapper::before {

  content: "";

  position: absolute;

  width: 55%;

  height: 70px;

  left: 22.5%;

  bottom: -20px;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(56,189,248,0.08),
      rgba(139,92,246,0.08),
      transparent
    );

  filter:
    blur(35px);

  pointer-events: none;
}


/* =========================================================
   SLIDE
   ========================================================= */

.testimonial-slide {

  padding:
    8px;

  box-sizing: border-box;
}


/* =========================================================
   CARD
   ========================================================= */

.testimonial-card {

  position: relative;

  height: 292px;

  display: flex;

  flex-direction: column;

  overflow: hidden;

  box-sizing: border-box;

  padding:
    20px 21px 17px;

  border-radius: 18px;

  background:
    linear-gradient(
      145deg,
      rgba(13,22,40,0.98),
      rgba(7,12,25,0.99)
    );

  border:
    1px solid rgba(56,189,248,0.11);

  box-shadow:

    0 18px 45px rgba(0,0,0,0.42),

    inset 0 1px 0
    rgba(255,255,255,0.025),

    0 0 25px
    rgba(56,189,248,0.02);

  transition:
    transform 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease;
}


.testimonial-card:hover {

  transform:
    translateY(-7px);

  border-color:
    rgba(56,189,248,0.38);

  box-shadow:

    0 25px 55px rgba(0,0,0,0.55),

    0 0 30px rgba(56,189,248,0.075),

    inset 0 1px 0
    rgba(255,255,255,0.035);
}


/* =========================================================
   CARD TOP LINE
   ========================================================= */

.testimonial-card-top {

  position: absolute;

  top: 0;

  left: 18%;
  right: 18%;

  height: 2px;

  background:
    linear-gradient(
      90deg,
      transparent,
      #38bdf8,
      #8b5cf6,
      transparent
    );

  box-shadow:
    0 0 12px rgba(56,189,248,0.5);
}


/* =========================================================
   CORNERS
   ========================================================= */

.card-corner {

  position: absolute;

  width: 18px;
  height: 18px;

  opacity: 0.45;

  pointer-events: none;
}


.card-corner-top {

  top: 11px;
  right: 12px;

  border-top:
    1px solid rgba(56,189,248,0.5);

  border-right:
    1px solid rgba(56,189,248,0.5);
}


.card-corner-bottom {

  bottom: 11px;
  left: 12px;

  border-bottom:
    1px solid rgba(139,92,246,0.45);

  border-left:
    1px solid rgba(139,92,246,0.45);
}


/* =========================================================
   QUOTE
   ========================================================= */

.testimonial-quote {

  position: absolute;

  top: 13px;
  left: 19px;

  color:
    #38bdf8;

  font-family:
    Georgia,
    serif;

  font-size: 40px;

  line-height: 1;

  font-weight: 700;

  opacity: 0.25;

  pointer-events: none;
}


/* =========================================================
   PROFILE
   ========================================================= */

.testimonial-profile {

  position: relative;

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 12px;

  margin-top: 5px;
}


/* =========================================================
   AVATAR RING
   ========================================================= */

.testimonial-avatar-ring {

  width: 64px;
  height: 64px;

  padding: 2px;

  flex-shrink: 0;

  border-radius: 50%;

  box-sizing: border-box;
}


/* STUDENTS = BLUE */

.student-ring {

  background:
    conic-gradient(
      #38bdf8,
      #93c5fd,
      #8b5cf6,
      #38bdf8,
      #2563eb,
      #38bdf8
    );

  box-shadow:
    0 0 20px rgba(56,189,248,0.14);
}


/* PARENTS = VIOLET */

.parent-ring {

  background:
    conic-gradient(
      #8b5cf6,
      #c4b5fd,
      #60a5fa,
      #8b5cf6,
      #6d28d9,
      #8b5cf6
    );

  box-shadow:
    0 0 20px rgba(139,92,246,0.14);
}


.testimonial-avatar {

  width: 100%;
  height: 100%;

  overflow: hidden;

  border-radius: 50%;

  background:
    #070d1b;

  border:
    2px solid #070d1b;

  box-sizing: border-box;
}


.testimonial-avatar img {

  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;
}


/* =========================================================
   PROFILE INFO
   ========================================================= */

.testimonial-profile-info {

  min-width: 0;

  text-align: left;
}


.testimonial-profile-info h3 {

  margin: 0;

  color: #ffffff;

  font-size: 13px;

  line-height: 1.35;

  font-weight: 750;

  letter-spacing: 0.1px;
}


.testimonial-type {

  display: inline-flex;

  align-items: center;

  margin-top: 5px;

  font-size: 8px;

  font-weight: 800;

  letter-spacing: 1.5px;

  text-transform: uppercase;
}


.student-type {

  color:
    #38bdf8;
}


.parent-type {

  color:
    #a78bfa;
}


/* =========================================================
   DIVIDER
   ========================================================= */

.testimonial-divider {

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 4px;

  margin:
    14px 0 11px;
}


.testimonial-divider::before,
.testimonial-divider::after {

  content: "";

  flex: 1;

  height: 1px;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(255,255,255,0.07)
    );
}


.testimonial-divider::after {

  background:
    linear-gradient(
      90deg,
      rgba(255,255,255,0.07),
      transparent
    );
}


.testimonial-divider span {

  width: 3px;
  height: 3px;

  border-radius: 50%;

  background:
    #38bdf8;

  box-shadow:
    0 0 5px rgba(56,189,248,0.5);
}


/* =========================================================
   TEXT
   ========================================================= */

.testimonial-text {

  margin: 0;

  min-height: 76px;

  color:
    #b7c3d4;

  font-size: 12px;

  line-height: 1.7;

  font-weight: 400;

  text-align: center;

  display: -webkit-box;

  -webkit-line-clamp: 4;

  -webkit-box-orient: vertical;

  overflow: hidden;
}


/* =========================================================
   FOOTER
   ========================================================= */

.testimonial-card-footer {

  display: flex;

  align-items: center;

  justify-content: space-between;

  margin-top: auto;

  padding-top: 11px;

  border-top:
    1px solid rgba(255,255,255,0.055);
}


.verified-badge {

  display: flex;

  align-items: center;

  gap: 6px;

  color:
    #68778d;

  font-size: 8px;

  font-weight: 700;

  letter-spacing: 0.4px;
}


.verified-icon {

  width: 15px;
  height: 15px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 50%;

  background:
    rgba(56,189,248,0.08);

  border:
    1px solid rgba(56,189,248,0.25);

  color:
    #38bdf8;

  font-size: 9px;
}


.footer-symbol {

  color:
    #8b5cf6;

  font-size: 13px;

  opacity: 0.6;
}


/* =========================================================
   CARD BOTTOM GLOW
   ========================================================= */

.testimonial-bottom-glow {

  position: absolute;

  left: 20%;
  right: 20%;

  bottom: -20px;

  height: 35px;

  filter:
    blur(25px);

  pointer-events: none;
}


.student-glow {

  background:
    rgba(56,189,248,0.055);
}


.parent-glow {

  background:
    rgba(139,92,246,0.055);
}


/* =========================================================
   SLICK
   ========================================================= */

.testimonial-slider-wrapper .slick-list {

  padding:
    6px 0 7px;
}


.testimonial-slider-wrapper .slick-track {

  display: flex;

  align-items: stretch;
}


.testimonial-slider-wrapper .slick-slide {

  height: auto;
}


.testimonial-slider-wrapper
.slick-slide > div {

  height: 100%;
}


/* =========================================================
   ARROWS
   ========================================================= */

.testimonial-slider-wrapper
.slick-prev,

.testimonial-slider-wrapper
.slick-next {

  z-index: 10;

  width: 40px;
  height: 40px;

  border-radius: 50%;

  border:
    1px solid rgba(56,189,248,0.22);

  background:
    rgba(5,10,21,0.94);

  box-shadow:
    0 0 18px rgba(56,189,248,0.05);

  transition:
    all 0.25s ease;
}


.testimonial-slider-wrapper
.slick-prev:hover,

.testimonial-slider-wrapper
.slick-next:hover {

  border-color:
    rgba(56,189,248,0.55);

  background:
    rgba(56,189,248,0.07);

  box-shadow:
    0 0 22px rgba(56,189,248,0.14);
}


.testimonial-slider-wrapper
.slick-prev {

  left: -43px;
}


.testimonial-slider-wrapper
.slick-next {

  right: -43px;
}


.testimonial-slider-wrapper
.slick-prev:before,

.testimonial-slider-wrapper
.slick-next:before {

  color:
    #38bdf8;

  font-size: 16px;

  opacity: 1;
}


/* =========================================================
   DOTS
   ========================================================= */

.testimonial-slider-wrapper
.slick-dots {

  bottom: -7px;
}


.testimonial-slider-wrapper
.slick-dots li {

  margin:
    0 2px;
}


.testimonial-slider-wrapper
.slick-dots li button:before {

  color:
    #64748b;

  opacity: 0.65;

  font-size: 8px;
}


.testimonial-slider-wrapper
.slick-dots
li.slick-active
button:before {

  color:
    #38bdf8;

  opacity: 1;

  text-shadow:
    0 0 9px #38bdf8;
}


/* =========================================================
   SECTION BOTTOM LINE
   ========================================================= */

.testimonials-bottom-line {

  position: absolute;

  bottom: 0;

  left: 15%;
  right: 15%;

  height: 1px;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(56,189,248,0.4),
      rgba(139,92,246,0.35),
      transparent
    );

  pointer-events: none;
}


/* =========================================================
   TABLET
   ========================================================= */

@media (max-width: 1100px) {

  .testimonial-slider-wrapper
  .slick-prev {

    left: -12px;
  }

  .testimonial-slider-wrapper
  .slick-next {

    right: -12px;
  }
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 768px) {

  .growniverse-testimonials {

    padding:
      55px 0 52px;
  }


  .testimonials-header {

    margin-bottom: 23px;

    padding:
      0 15px;
  }


  .testimonials-title {

    font-size:
      clamp(28px, 8vw, 38px);
  }


  .testimonials-description {

    font-size: 12px;

    max-width: 400px;
  }


  .testimonials-tabs {

    margin-bottom: 20px;
  }


  .testimonial-tab {

    min-width: 105px;

    height: 36px;

    padding:
      0 15px;
  }


  .testimonial-slider-wrapper {

    padding:
      12px 5px 35px;

    border-radius: 20px;
  }


  .testimonial-slide {

    padding:
      8px 6px;
  }


  .testimonial-card {

    height: 292px;

    padding:
      19px 18px 16px;
  }


  .testimonial-slider-wrapper
  .slick-prev,

  .testimonial-slider-wrapper
  .slick-next {

    display: none !important;
  }


  .testimonials-glow {

    opacity: 0.65;
  }
}


/* =========================================================
   SMALL MOBILE
   ========================================================= */

@media (max-width: 480px) {

  .growniverse-testimonials {

    padding:
      48px 0 46px;
  }


  .testimonials-eyebrow {

    font-size: 9px;

    letter-spacing: 1.6px;

    padding:
      6px 12px;
  }


  .testimonials-title {

    font-size: 29px;

    letter-spacing: -0.7px;
  }


  .testimonials-description {

    font-size: 11px;

    line-height: 1.6;
  }


  .testimonials-tabs {

    gap: 6px;
  }


  .testimonial-tab {

    min-width: 100px;

    height: 35px;

    font-size: 10px;
  }


  .testimonial-slider-wrapper {

    border-radius: 18px;
  }


  .testimonial-card {

    height: 285px;

    border-radius: 15px;
  }


  .testimonial-avatar-ring {

    width: 60px;
    height: 60px;
  }


  .testimonial-profile-info h3 {

    font-size: 12px;
  }


  .testimonial-text {

    font-size: 11.5px;

    line-height: 1.65;
  }


  .testimonials-glow {

    opacity: 0.5;
  }
}


/* =========================================================
   VERY SMALL PHONES
   ========================================================= */

@media (max-width: 360px) {

  .growniverse-testimonials {

    padding:
      42px 0 42px;
  }


  .testimonials-title {

    font-size: 26px;
  }


  .testimonials-description {

    font-size: 10.5px;
  }


  .testimonial-card {

    height: 280px;

    padding:
      17px 15px 14px;
  }


  .testimonial-avatar-ring {

    width: 56px;
    height: 56px;
  }


  .testimonial-text {

    font-size: 11px;
  }
}


/* =========================================================
   REDUCED MOTION
   ========================================================= */

@media (prefers-reduced-motion: reduce) {

  .testimonial-card,

  .testimonial-tab,

  .testimonial-slider-wrapper
  .slick-prev,

  .testimonial-slider-wrapper
  .slick-next {

    transition: none !important;
  }
}

`}</style>
    </>
  );
};

export default Testimonials;